import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal, ModalBody, Label, CustomInput } from 'reactstrap';
import { uniqueId } from 'lodash';
import Translate, { t } from '../common/Translate';
import useValue from '../../services/Form/useValue';
import DisplayElement from './DisplayElement';
import { useImage } from '../../services/Image/useImage';

const AlertElement = (props) => {
  const { question, elementIds, goNextQuestion } = props;
  const { questionId, sectionId, formId } = elementIds;
  const { setDisableNav } = props;
  const { custom_cost, options, type } = question;
  const [value, setValue, refreshValue] = useValue(formId, sectionId, questionId, type, 'value');
  const [forceRefresh, setForceRefresh] = useState(true);
  const [customCostModalShown, setCustomCostModalShown] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [filterOptions, setFilterOptions] = useState([]);
  let opt = [];

  const filter = (v) => {
    Object.keys(v).forEach((key) => {
      if (filterOptions.includes(key)) {
        opt = filterOptions.filter((ele) => ele !== key);
        setFilterOptions(opt);
        refreshValue();
      }
    });
  };

  useEffect(() => {
    if (value && typeof value === 'object') {
      filter(value);
    } else {
      setFilterOptions(options);
    }
  }, [value]);

  const forceAddedDamagesRefresh = () => {
    if (forceRefresh) setForceRefresh(false);
    else setForceRefresh(true);
  };

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (value !== null && value !== '' && value !== undefined) setDisableNav(false);
      else setDisableNav(true);
    }
  });

  const onClick = (option) => {
    if (option === 'ok') setValue(option);
    if (goNextQuestion) goNextQuestion();
  };

  const setMultipleValues = (option, label = null) => {
    let newObject = {};
    if (value !== undefined && value !== null && typeof value === 'object') newObject = { ...value };
    if (Object.values(custom_cost).indexOf(option) > -1 && label === null) {
      setSelectedOption(option);
      setCustomCostModalShown(true);
      return;
    }
    setSelectedOption(option);
    newObject[option] = label;
    setValue(newObject);
  };

  const closeModal = () => {
    setCustomCostModalShown(false);
  };

  const addOptionToFilter = (val) => {
    Object.keys(val).forEach((key) => {
      opt = options.filter((ele) => ele !== key);
      setFilterOptions(opt);
      refreshValue();
    });
  };

  return (
    <div className="question-select" data-cy={questionId}>
      {value !== null &&
        value !== undefined &&
        typeof value === 'object' &&
        Object.entries(value).map((option, key) => (
          <AddedAlert
            initialValue={value}
            option={option}
            questionId={questionId}
            questionType={type}
            formId={formId}
            sectionId={sectionId}
            displayValue={option[1]}
            setValue={setValue}
            key={uniqueId(key)}
            id={key}
            addOptionToFilter={addOptionToFilter}
            refreshParent={forceAddedDamagesRefresh}
          />
        ))}
      <Row>
        <Col xs="4" md="3" lg="3">
          <button
            type="button"
            color="primary"
            className={
              (value === 'ok' && 'btn btn-block btn-value h-90 mt-4 selected') || 'btn btn-block btn-value h-90 mt-4'
            }
            data-cy={(value !== null && typeof value === 'object' && 'Finish') || 'ok'}
            onClick={() => onClick((value !== null && typeof value === 'object' && 'Finish') || 'ok')}
          >
            <Translate code={(value !== null && typeof value === 'object' && 'Finish') || 'ok'} />
          </button>
        </Col>

        <Col xs="8" md="3" lg="3">
          <Label className="text-left h-60 mt-1">
            <Translate code="Anomalie" />
          </Label>
          <CustomInput
            id="element"
            className="text-left form-control"
            type="select"
            onChange={(e) => {
              setMultipleValues(e.target.value);
            }}
            data-cy="element"
          >
            <option value="">{t('select_element')}</option>
            {filterOptions !== undefined &&
              filterOptions !== null &&
              Object.values(filterOptions).map((option) => (
                <option key={option} value={option}>
                  {t(option)}
                </option>
              ))}
          </CustomInput>
          <InputAnomial
            {...props}
            isOpen={customCostModalShown}
            setMultipleValues={setMultipleValues}
            selectedOption={selectedOption}
            closeModal={closeModal}
          />
        </Col>
      </Row>
    </div>
  );
};

export default AlertElement;

AlertElement.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['boolean']).isRequired,
    custom_cost: PropTypes.shape(),
    add_picture: PropTypes.shape(),
    default_value: PropTypes.string,
    options: PropTypes.shape(),
  }),
  elementIds: PropTypes.shape({
    questionId: PropTypes.string.isRequired,
    sectionId: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
  }).isRequired,
  setDisableNav: PropTypes.func,
  goNextQuestion: PropTypes.func,
};

AlertElement.defaultProps = {
  question: {
    custom_cost: undefined,
    add_picture: undefined,
    default_value: null,
    options: null,
  },
  setDisableNav: undefined,
  goNextQuestion: undefined,
};

const AddedAlert = ({
  initialValue,
  option,
  questionId,
  questionType,
  setValue,
  id,
  formId,
  sectionId,
  displayValue,
  addOptionToFilter,
  refreshParent,
}) => {
  const [image, setImage, deleteImage] = useImage(
    formId,
    `inspection.children.${sectionId}.children.${questionId}.images.${option[0]}`,
    questionId,
    questionType,
  );

  const handleUploadImage = (e) => {
    setImage(e.target.files[0]);
  };

  const handleDeleteBlock = () => {
    let selectOptions = {};
    if (!initialValue || typeof initialValue !== 'object') {
      setValue(null);
    } else {
      selectOptions = { ...initialValue };
      delete selectOptions[option[0]];
      if (Object.keys(selectOptions).length === 0) setValue(null);
      else setValue(selectOptions);
      addOptionToFilter(selectOptions);
    }
    deleteImage();
    refreshParent();
  };

  return (
    <div>
      <DisplayElement
        id={id}
        image={image}
        element={option[0]}
        displayValue={displayValue}
        handleDeleteBlock={handleDeleteBlock}
        handleUploadImage={handleUploadImage}
        type={questionId}
      />
    </div>
  );
};

AddedAlert.propTypes = {
  initialValue: PropTypes.shape(),
  option: PropTypes.shape(),
  questionId: PropTypes.string.isRequired,
  questionType: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  displayValue: PropTypes.string.isRequired,
  addOptionToFilter: PropTypes.func.isRequired,
  refreshParent: PropTypes.func.isRequired,
};

AddedAlert.defaultProps = {
  initialValue: null,
  option: null,
};

const InputAnomial = ({ questionId, closeModal, selectedOption, setMultipleValues, isOpen }) => {
  const [text, setText] = useState(null);
  const [modalButtonDisable, setModalButtonDisable] = useState(true);

  const validateValue = () => {
    setMultipleValues(selectedOption, text);
    closeModal();
  };

  if (text !== null && modalButtonDisable) setModalButtonDisable(false);

  const handleChangeElement = (e) => {
    const element = e.target.value;
    if (element.length === 0) {
      setText(null);
      setModalButtonDisable(true);
    } else setText(e.target.value);
  };

  return (
    <Modal isOpen={isOpen} centered>
      <ModalBody>
        <label className="pl-2 text-left">
          <Translate code="description de l'anomalie" />
        </label>
        <input
          id="anomial"
          name="anomial"
          data-cy="anomial"
          type="text"
          className="text-left form-control"
          placeholder="Ex: Siege déchiré"
          onChange={(e) => handleChangeElement(e)}
        />
        <Row className="mt-4 mb-2">
          <Col xs="6" className="text-right" data-cy={questionId}>
            <button type="button" className="btn btn-link px-4" onClick={closeModal} data-cy="model-cancel-btn">
              <Translate code="cancel" />
            </button>
          </Col>
          <Col xs="6" className="text-left" data-cy="validateDamage">
            <button
              type="submit"
              className="btn btn-primary px-4 shadow"
              disabled={modalButtonDisable}
              onClick={validateValue}
            >
              <Translate code="validate" />
            </button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

InputAnomial.propTypes = {
  questionId: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  selectedOption: PropTypes.string.isRequired,
  setMultipleValues: PropTypes.func.isRequired,
  isOpen: PropTypes.func.isRequired,
};
